import React, { useEffect, useRef } from "react";
import { Button, LogoLoader } from ".";
import { formatWords2 } from "../utils/stringUtils";
import { useNavigate } from "react-router-dom";

const SearchCard = ({
  searchQuery = "",
  searchType = "search_applicant",
  isJobPostingView = false,
  onCountChange,
  data = [],
  loading,
  onClose
}) => {
  const navigate = useNavigate();
  const jobPostings = [
    {
      id: 1,
      role: "Software Engineer",
      company: "Tech Co.",
      location: "New York",
    },
    {
      id: 2,
      role: "Product Manager",
      company: "Startup Inc.",
      location: "San Francisco",
    },
    {
      id: 3,
      role: "Data Scientist",
      company: "DataWorks",
      location: "Arizona",
    },
    {
      id: 3,
      role: "Data Scientist",
      company: "DataWorks",
      location: "California",
    },
    {
      id: 1,
      role: "Software Engineer",
      company: "Tech Co.",
      location: "New York",
    },
    {
      id: 2,
      role: "Product Manager",
      company: "Startup Inc.",
      location: "San Francisco",
    },
    { id: 3, role: "Data Scientist", company: "DataWorks", location: "Remote" },
    { id: 3, role: "Data Scientist", company: "DataWorks", location: "Remote" },
    {
      id: 1,
      role: "Software Engineer",
      company: "Tech Co.",
      location: "New York",
    },
    {
      id: 2,
      role: "Product Manager",
      company: "Startup Inc.",
      location: "San Francisco",
    },
    { id: 3, role: "Data Scientist", company: "DataWorks", location: "Remote" },
    { id: 3, role: "Data Scientist", company: "DataWorks", location: "Remote" },
    {
      id: 1,
      role: "Software Engineer",
      company: "Tech Co.",
      location: "New York",
    },
    {
      id: 2,
      role: "Product Manager",
      company: "Startup Inc.",
      location: "San Francisco",
    },
    {
      id: 3,
      role: "Data Scientist",
      company: "DataWorks",
      location: "San Francisco",
    },
    {
      id: 3,
      role: "Data Scientist",
      company: "DataWorks",
      location: "Florida",
    },
  ];

  const applicants = [
    {
      id: 1,
      name: "John Doe",
      email: "john@example.com",
      mobile: "+1 (123) 456-7890",
    },
    {
      id: 2,
      name: "Jane Smith",
      email: "jane@example.com",
      mobile: "+1 (123) 456-7891",
    },
    {
      id: 3,
      name: "Chris Johnson",
      email: "chris@example.com",
      mobile: "+1 (123) 456-7892",
    },
    {
      id: 4,
      name: "Emily Davis",
      email: "emily@example.com",
      mobile: "+1 (123) 456-7893",
    },
    {
      id: 5,
      name: "Michael Brown",
      email: "michael@example.com",
      mobile: "+1 (123) 456-7894",
    },
    {
      id: 6,
      name: "Sarah Wilson",
      email: "sarah@example.com",
      mobile: "+1 (123) 456-7895",
    },
    {
      id: 7,
      name: "David Lee",
      email: "david@example.com",
      mobile: "+1 (123) 456-7896",
    },
    {
      id: 8,
      name: "Sophia Miller",
      email: "sophia@example.com",
      mobile: "+1 (123) 456-7897",
    },
    {
      id: 9,
      name: "Emily Davis",
      email: "emily@example.com",
      mobile: "+1 (123) 456-7893",
    },
    {
      id: 10,
      name: "Michael Brown",
      email: "michael@example.com",
      mobile: "+1 (123) 456-7894",
    },
    {
      id: 11,
      name: "Sarah Wilson",
      email: "sarah@example.com",
      mobile: "+1 (123) 456-7895",
    },
    {
      id: 12,
      name: "David Lee",
      email: "david@example.com",
      mobile: "+1 (123) 456-7896",
    },
    {
      id: 13,
      name: "Sophia Miller",
      email: "sophia@example.com",
      mobile: "+1 (123) 456-7897",
    },
    {
      id: 14,
      name: "Emily Davis",
      email: "emily@example.com",
      mobile: "+1 (123) 456-7893",
    },
    {
      id: 15,
      name: "Michael Brown",
      email: "michael@example.com",
      mobile: "+1 (123) 456-7894",
    },
    {
      id: 16,
      name: "Sarah Wilson",
      email: "sarah@example.com",
      mobile: "+1 (124) 456-7895",
    },
  ];
 
 const prevCountRef = useRef(null);

  const searchLower = searchQuery.toLowerCase();

  const filteredApplicants = applicants.filter(
    (applicant) =>
      applicant.name.toLowerCase().includes(searchLower) ||
      applicant.email.toLowerCase().includes(searchLower) ||
      applicant.mobile.toLowerCase().includes(searchLower)
  );

  const filteredJobPostings = jobPostings.filter(
    (job) =>
      job.role.toLowerCase().includes(searchLower) ||
      job.company.toLowerCase().includes(searchLower) ||
      job.location.toLowerCase().includes(searchLower)
  );
   const count =
    searchType === "search_applicant"
      ? filteredApplicants.length
      : filteredJobPostings.length;

  useEffect(() => {
    if (prevCountRef.current !== count) {
      prevCountRef.current = count;
      onCountChange?.(count);
    }
  }, [count, onCountChange]);

  const renderCard = (item, type) => (
    <div className="p-4 shadow-md rounded-lg space-y-1 border border-primary-50 mt-2 font-normal">
      {type === "search_applicant" && (
        <div className="text-xl font-medium text-black-500 mb-2">
          {<div className="text-sm text-gray-500">ID: {item.id}</div>}
          <span>{item.name}</span>
        </div>
      )}

      {type === "job_postings" && item.role && (
        <div className="flex font-normal text-black-500 items-center gap-2">
          <Button
            icon="business_center"
            color="dark"
            size="xs-sm"
            type="icon"
          />
          <span>{item.id}</span>
          <span>{item.role}</span>
        </div>
      )}

      {type === "job_postings" && item.company && (
        <div className="flex text-md text-black items-center gap-2">
          <Button icon="corporate_fare" color="dark" size="xs-sm" type="icon" />
          <span>{item.company}</span>
        </div>
      )}

      {item.location && (
        <div className="flex text-sm text-black gap-2">
          <Button icon="location_on" color="dark" size="xs-sm" type="icon" />
          <span>{item.location}</span>
        </div>
      )}

      {type === "search_applicant" && item.email && (
        <div className="flex items-center text-sm text-black gap-2 mt-2">
          <Button icon="mail" color="dark" size="xs-sm" type="icon" />
          <span>{item.email}</span>
        </div>
      )}

      {type === "search_applicant" && item.mobile && (
        <div className="flex items-center text-sm text-black gap-2 mt-2">
          <Button icon="call" color="dark" size="xs-sm" type="icon" />
          <span>{item.mobile}</span>
        </div>
      )}
    </div>
  );
  const renderCandidateCard = (item) => {
    const handleApplicantClick = () => {
      onClose?.();
      navigate("/ats/applicants/applicant-details", {
        state: { applicantId: item?.uiid },
      });
    };
    return (
      <div
        key={item?._id}
        className="p-4 shadow-md rounded-lg border cursor-pointer border-primary-50 mt-2 hover:shadow-xl"
        onClick={handleApplicantClick}
      >
        <div className="text-sm text-gray-500">ID: {item?.uiid}</div>

        <div className="text-lg font-medium break-all">
          {formatWords2(item?.firstName)} {formatWords2(item?.lastName)}
        </div>

        {item.email?.primary?.email && (
          <div className="flex items-center text-sm text-black gap-2 mt-2">
            <Button icon="mail" color="dark" size="xs-sm" type="icon" />
            <span className="break-all">{item.email?.primary?.email}</span>
          </div>
        )}

        {item?.mobile?.primary?.number && (
          <div className="flex items-center text-sm text-black gap-2 mt-2">
            <Button icon="call" color="dark" size="xs-sm" type="icon" />
            <span>{item.mobile?.primary?.code} {item.mobile?.primary?.number}</span>
          </div>
        )}
      </div>
    );
  }
  const renderJobPostingCard = (item) => {
    const handleJobClick = () => {
      sessionStorage.setItem("selectedJobUiid", item?.uiid);
      sessionStorage.setItem("prevJobsPage", window.location.pathname);
      onClose?.();
      navigate("/ats/jobs/job-details?job-details=info");
    };
    return (
      <div
        key={item?._id}
        className="p-4 shadow-md rounded-lg border border-primary-50 mt-2 cursor-pointer hover:shadow-xl"
        onClick={handleJobClick}
      >
        <div className="flex items-center gap-2">
          <Button icon="business_center" color="dark" size="xs-sm" type="icon" />
          {item?.uiid} {formatWords2(item?.jobId?.title)}
        </div>

        {item?.companyId?.name && (
          <div className="flex text-md text-black items-center gap-2">
            <Button icon="corporate_fare" color="dark" size="xs-sm" type="icon" />
            {formatWords2(item?.companyId?.name)}
          </div>
        )}

        {item?.jobInfo?.location?.city && (
          <div className="flex items-center text-sm gap-2 mt-2">
            <Button icon="location_on" color="dark" size="xs-sm" type="icon" />
            {[
              item.jobInfo.location?.city,
              item.jobInfo.location?.state
            ].filter(Boolean).join(", ")}
          </div>
        )}
      </div>
    );
  }

//   if (loading) {
//   return (
//     <div className="mt-10 flex items-center justify-center">
//       <LogoLoader />
//     </div>
//   );
// }

  // if (!data.length) {
  //   return <div className="mt-5 text-center">No results found</div>;
  // }

  return (
    <div className="mt-5">
      <div className="grid grid-cols-4 gap-10 mb-3">
        {/* {searchType === "search_applicant"
          ? filteredApplicants.map((applicant) =>
              renderCard(applicant, "search_applicant")
            )
          : filteredJobPostings.map((job) => renderCard(job, "job_postings"))} */}
          {searchType === "search_applicant"
            ? data.map(renderCandidateCard)
            : data.map(renderJobPostingCard)}
      </div>
      {loading && <div className="mt-5 flex items-center justify-center">
      <LogoLoader />
    </div>}
    {!loading && data.length === 0 && (
      <div className="mt-5 text-center">No results found</div>
    )}
    </div>
  );
};

export default SearchCard;
